// Firebase Configuration
// Replace these values with your actual Firebase project credentials
// from https://console.firebase.google.com

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  // PASTE YOUR CONFIG HERE — the block you copied in Step 2.5
  apiKey: "AIzaSyDIryEPB43iesOEmDAjBeT3erLaYHuw5QA",
  authDomain: "ak-dispatching.firebaseapp.com",
  projectId: "ak-dispatching",
  storageBucket: "ak-dispatching.firebasestorage.app",
  messagingSenderId: "75755125593",
  appId: "1:75755125593:web:adb77e7d915aac37bc6a48",
  measurementId: "G-Z6TD1JRP3M"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export default app;

